import { configureStore } from '@reduxjs/toolkit';
import timeSlice from './timeSlice';

const store = configureStore({
  reducer: {
    time: timeSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
